import {AvatarEmotion, AvatarGesture} from "../../../schema";
import {PlayerReduxDispatch, PlayerReduxState} from "../types";

function appendInitPhraseToDialogueHistory(
  dispatch: PlayerReduxDispatch,
  getState: () => PlayerReduxState,
  initAgentAction: NonNullable<PlayerReduxState["initAgentAction"]>,
) {
  const text = (initAgentAction.text ?? "").trim();
  if (!text) {
    return;
  }
  const id = `init-agent-${initAgentAction.uuid}`;
  if (getState().dialogueHistory?.some((e) => e.action.id === id)) {
    return;
  }
  dispatch({
    type: "appendDialogueHistory",
    payload: {
      action: {
        __typename: "AvatarAction",
        id,
        text: initAgentAction.text ?? "",
        emotion: AvatarEmotion.IDLE,
        gesture: AvatarGesture.GREETINGS,
        isCustomAudio: !!initAgentAction.url,
        audio: initAgentAction.url,
      },
    },
  });
}

export default function playInitAgentAction() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();
    const isSpeechMuted = state.challenge.muteNonUserSpeech;
    const avatarPlayback = state.audioManager.getPlayback("player/avatar");
    const initAgentAction = state.initAgentAction;
    const audio = initAgentAction?.url;

    if (audio && avatarPlayback && initAgentAction) {
      avatarPlayback.abortPlay();
      dispatch({type: "update", payload: {isRecognizing: true}});
      avatarPlayback
        .play(audio, {volume: isSpeechMuted ? 0 : undefined})
        .then(() => {
          appendInitPhraseToDialogueHistory(dispatch, getState, initAgentAction);
          dispatch({
            type: "update",
            payload: {
              isRecognizing: false,
              initAgentAction: {...initAgentAction, played: true},
            },
          });
        })
        .catch((reason) => {
          if (reason === "ABORT") {
            return;
          }
          appendInitPhraseToDialogueHistory(dispatch, getState, initAgentAction);
          dispatch({
            type: "update",
            payload: {
              isRecognizing: false,
              initAgentAction: {...initAgentAction, played: true},
            },
          });
        });
    } else if (initAgentAction) {
      appendInitPhraseToDialogueHistory(dispatch, getState, initAgentAction);
      dispatch({
        type: "update",
        payload: {initAgentAction: {...initAgentAction, played: true}},
      });
    }
  };
}
